import e from"./ClearRefinements.vue_vue&type=script&lang.js";import{render as t}from"./ClearRefinements.vue_vue&type=template&id=74399990&lang.js";e.render=t;export default e;
//# sourceMappingURL=ClearRefinements.vue.js.map
